// app/components/blog/BlogCardSkeleton.tsx
import Skeleton from '@/app/components/utils/Skeleton';

export default function BlogCardSkeleton() {
  return (
    <div className="w-full flex flex-col md:flex-row mt-4 mb-8">
      <div className="relative w-full max-w-3xl mx-auto xl:ml-24">
        <Skeleton className="w-full h-48 md:h-72 rounded-2xl" />
        <div className="pt-3 md:pt-4">
          <Skeleton className="h-4 w-24 mb-2 rounded" />
          <Skeleton className="h-6 w-3/4 mb-3 rounded" />
          <Skeleton className="h-4 w-full mb-2 rounded" />
          <Skeleton className="h-4 w-5/6 mb-2 rounded" />
          <Skeleton className="h-8 w-32 mt-4 rounded-lg" />
        </div>
      </div>
    </div>
  );
}
